import Vue from "vue";
import VueRouter from "vue-router";
import Layout from '@/layout/index.vue'
import Deliveries from '@/views/Deliveries.vue';

import { authService } from '../services/authService';

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "deliveries",
    redirect: '/deliveries/index',
    meta: {
      requiresAuth: true
    },
  },
  {
    path: "/deliveries/",
    name: "deliveries",
    redirect: '/deliveries/index',
    component: Layout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: 'Deliveries',
        path: 'index',

        component: Deliveries
      }
    ]
  },
  {
    path: "/quality",
    name: "quality",
    redirect: '/quality/index',
    component: Layout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: 'Quality',
        path: 'index',
        component: () => import(/* webpackChunkName: "about" */ "@/views/Quality.vue")
      },
    ]
  },
  {
    path: "/mydevelopement",
    name: "mydevelopement",
    redirect: '/mydevelopement/index',
    component: Layout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: 'MyDevelopement',
        path: 'index',
        component: () => import(/* webpackChunkName: "about" */ "@/views/MyDevelopement.vue")
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let isAuthenticated = await authService.getAuthenticated();
    
    if (!isAuthenticated) {
      console.log('[VueRouter] Not authenticated. Url:' + to.fullPath);
      authService.signinWithRedirect(to.fullPath);
    }
    else{
      next()
    }
  } else {
    // No auth needed.
    next()
  }
})

export default router;
